import React, { useLayoutEffect } from "react";

import ErrorElement from "components/ErrorElement";
import LoadingScreen from "components/shared/LoadingScreen";
import { ChunkReloadStatus, STORAGE_CHUNK_RELOAD_FLAG } from "globalConstants/storage";
import { isChunkLoadError, triggerChunkReload } from "utils/chunkReload";

type ChunkLoadErrorFallbackProps = { error: unknown; fallback?: React.ReactNode };

export function shouldAttemptChunkReload(error: unknown): boolean {
  if (!isChunkLoadError(error)) return false;

  const flag = sessionStorage.getItem(STORAGE_CHUNK_RELOAD_FLAG);
  return flag !== ChunkReloadStatus.DONE && flag !== ChunkReloadStatus.PENDING;
}

const ChunkLoadErrorFallback = ({ error, fallback = <ErrorElement /> }: ChunkLoadErrorFallbackProps): JSX.Element => {
  useLayoutEffect(() => {
    if (shouldAttemptChunkReload(error)) {
      triggerChunkReload();
    }
  }, [error]);

  const flag = sessionStorage.getItem(STORAGE_CHUNK_RELOAD_FLAG);

  if (flag === ChunkReloadStatus.PENDING) {
    return <LoadingScreen />;
  }

  if (isChunkLoadError(error) && flag !== ChunkReloadStatus.DONE) {
    return <LoadingScreen />;
  }

  return <>{fallback}</>;
};

export default ChunkLoadErrorFallback;
